import clsx from "clsx";
import NavigationContext from "context/NavigationContext";
import React from "react";
import { BsDot } from "react-icons/bs";
import { useSelector } from "react-redux";
import { NavLink, useHistory } from "react-router-dom";
import { selectThemeDirection } from "redux/theme/theme.selectors";
import { createStructuredSelector } from "reselect";
import DashboardUtils from "../../../utils/DashboardUtils";

const DashboardNavItem = (props) => {
  const { item } = props;
  const history = useHistory();

  const { handleDrawerToggle, isDrawerClose } =
    React.useContext(NavigationContext);

  const { themeDirection } = useSelector(
    createStructuredSelector({
      themeDirection: selectThemeDirection,
    })
  );

  const userRole = useSelector(({ auth }) => auth.user.role);
  if (!DashboardUtils.hasPermission(item.auth, userRole)) {
    return null;
  }

  return (
    <NavLink
      to={item.url}
      className="nav-link d-flex cu-bg-blue-dark-hover text-white"
      activeClassName={clsx(
        "navlink-active",
        themeDirection === "rtl" ? "navlink-active-rtl" : "navlink-active-ltr"
      )}
      isActive={(match, location) => {
        if (item.url === location.pathname) return true;
      }}
      exact={item.exact}
      onClick={() => {
        if (
          item.url === window.location.pathname &&
          item.url !== window.location.pathname + window.location.search
        ) {
          history.replace(item.url);
          window.location.reload();
        }
        if (isDrawerClose) return;
        handleDrawerToggle();
      }}
    >
      <BsDot />
      {/* <Icon className="mr-2 align-middle cu-text-md">{item.icon}</Icon>{" "} */}
      {item.title}
    </NavLink>
  );
};

export default DashboardNavItem;
